import './confirm-modal.style.sass';
import template from './confirm-modal.tpl.pug';

class ConfirmDeleteController {
    $onChanges(changeObject) {
        if (changeObject.message) {
            this.paragraphs = typeof this.message === 'string'
                ? [this.message]
                : this.message;
        }

        if (changeObject.primaryButton) {
            if (typeof this.primaryButton === 'string') {
                this.primaryButtonText = this.primaryButton;
                this.primaryButtonLoadingText = this.primaryButtonText;
            } else if (this.primaryButton) {
                this.primaryButtonText = this.primaryButton[0];
                this.primaryButtonLoadingText = this.primaryButton[1] || this.primaryButtonText;
            } else {
                this.primaryButtonText = 'Yes, delete';
                this.primaryButtonLoadingText = 'Deleting...';
            }
        }

        if (changeObject.secondaryButton) {
            this.secondaryButtonText = this.secondaryButton || 'Cancel';
        }

        if (changeObject.buttonStyle) {
            this.buttonStyleClass = this.buttonStyle || 'button-danger';
        }
    }

    $onInit() {
        this.buttonStyleClass = this.buttonStyle || 'button-danger';
    }

    cancel() {
        return this.onDismiss();
    }

    confirm() {
        return this.onClose();
    }
}

export default {
    selector: 'dbAConfirmModal',
    template: template(),
    controller: ConfirmDeleteController,
    bindings: {
        title: '<',
        message: '<',
        primaryButton: '<',
        secondaryButton: '<',
        buttonStyle: '<',
        onDismiss: '&',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/confirm-modal/confirm-modal.cmpt.js